import { isEmpty } from "lodash";
import { ACCOUNT_SETTING_LIST, GET_DEFAULT_FORM_LIST, ADD_UPDATE_ACCOUNT_SETTING, GET_SETTING_DETAIL, GET_ACCOUNT_SETTING_DETAIL, GET_SELF_REGISTERATION, ADD_SELF_REGISTERATION, GET_THIRD_PARTY_INTEGRATION_STATUS, CONNECT_STRIPE_ACCOUNT, DISCONNECT_STRIPE_ACCOUNT, GET_EXPORT_REQUEST_STATUS, GET_EXPORT_REQUEST_LIST } from 'store/actions/accountSetting';

const initialState = {
    isAuthenticated: false,
    accountSettingList: [],
    defaultFormList : [],
    accountSettingDetail : {},
    accountSettingDetail_ : {},
    self_registeration_list : [],
    integrations: [],
    dataExport: {
      exportRequests: [],
      utlizedRequests: 0,
      remainingExportRequests: 0,
      maxExportRequests: 0,
    },
    loader:false,
};

//get 
const getAccountSettingList = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
        ...state,
        isAuthenticated: true,
        accountSettingList:data.body,
    };
  return stateObj;
};

//default form list
const getDefaultFormList = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
        ...state,
        isAuthenticated: true,
        defaultFormList:data.body,
    };
  return stateObj;
};

//add update account setting
const addUpdateAccountSetting = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
    };
    return stateObj;
};

//get detail setting
const getSettingDetail = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
      callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      accountSettingDetail:data.body,
    };
    return stateObj;
};

//get detail setting
const getAccountSettingDetail = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    accountSettingDetail_:data.body,
  };
  return stateObj;
};

//self registeration
const getSelfRegisteration = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    self_registeration_list:data.body,
  };
  return stateObj;
};

//add self registeration
const addSelfRegisteration = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    self_registeration_list:data.body,
  };
  return stateObj;
};

// third party integration status
const getIntegrationStatus = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    integrations: data.body
  };
  return stateObj;
};

// Get export data request list
const getExportRequestList = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }

  const requests = data?.body?.requests;

  const stateObj = {
    ...state,
    dataExport: {
      ...state.dataExport,
      exportRequests: requests?.length ? requests : [],
      utlizedRequests: data?.body?.utlizedRequests,
      remainingExportRequests: data?.body?.remainingRequests,
      maxExportRequests: data?.body?.maxExportRequests,
    }
  };
  return stateObj;
};


const AccountSetting = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case ACCOUNT_SETTING_LIST:
          return getAccountSettingList(state, payload);
        case GET_DEFAULT_FORM_LIST:
          return getDefaultFormList(state, payload);
        case ADD_UPDATE_ACCOUNT_SETTING:
          return addUpdateAccountSetting(state, payload);
        case GET_SETTING_DETAIL:
          return getSettingDetail(state, payload);
        case GET_ACCOUNT_SETTING_DETAIL:
          return getAccountSettingDetail(state, payload);
        case GET_SELF_REGISTERATION:
          return getSelfRegisteration(state, payload);
        case ADD_SELF_REGISTERATION:
          return addSelfRegisteration(state, payload);
        case GET_THIRD_PARTY_INTEGRATION_STATUS:
          return getIntegrationStatus(state, payload);
        case GET_EXPORT_REQUEST_LIST:
          return getExportRequestList(state, payload);
        default:
        return state;
    };
}
export default AccountSetting;